import {PagerEventData} from '../../data/pager-event-data';
import {EventType} from '../../enum/event-type';
import {PageKind} from '../../enum/page-kind';
import {EmitService} from '../event/emit.service';
import {EmitterEvent} from '../event/prototype/emitter-event';
import {Injectable} from '@angular/core';

@Injectable()
export class PageManagementService extends EmitService {

  private _kind: PageKind;
  private _currentPage: number;

  constructor() {
    super();

    this._kind = PageKind.SIGNIN;
    this._currentPage = -1;
  }

  public set pageKind(order: PageKind) {
    this._kind = order;
    this.refreshPagerStatus();
  }

  public set currentPageNum(order: number) {
    this._currentPage = order;
    console.log('new page num:' + this._currentPage);
  }

  private refreshPagerStatus(): void {
    const sendData: PagerEventData = {
      kind: this._kind,
      isEnabled: false,
      currentPageNum: this._currentPage
    };

    switch (this._kind) {
      case PageKind.SIGNIN:
        break;
      case PageKind.INTRODUCTION:
      case PageKind.DOWNLOAD:
        sendData.isEnabled = true;
        break;
      default:
        break;
    }

    this.dispatcher(new EmitterEvent(EventType.REFRESH_PAGER_ICON, sendData));
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/pager/page-management.service.ts